// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"97efb709","453":"6884c61b","455":"6f49c644","644":"48c8df23"}[chunkId] + ".chunk.js";
};